<div class="loading" *ngIf="loading"><myapp-loading></myapp-loading></div>
<div *ngIf="!loading">

    <myapp-org-header [album]="album"></myapp-org-header>
    <myapp-breadcrumb [album]="album"></myapp-breadcrumb>
    <div class="no-images" *ngIf="album?.ChildAlbums.length === 0">There are no albums in this gallery.</div>

    <div class="album-grid">
        <div *ngFor="let childAlbum of album?.ChildAlbums; let i = index" class="child-album-container col-md-6 col-lg-4">
            <div class="child-album" (click)="onChildAlbumSelected(childAlbum)">
                <myapp-image-asset class="child-album-image" [imageAsset]="childAlbum.Thumbnail" [width]="140" [height]="140"
                                   [usePlaceholder]="true" [useBorder]="false"></myapp-image-asset>
                <div class="child-album-info">
                    <div class="child-album-info-name">{{childAlbum.Name}}</div>
                    <div *ngIf="!childAlbum.IsFolder" class="child-album-photo-count">Photos: {{childAlbum.PhotosCount}}</div>
                    <div *ngIf="!childAlbum.IsFolder" class="child-album-video-count">Videos: {{childAlbum.VideosCount}}</div>
                    <div *ngIf="!childAlbum.IsPublished" class="child-album-not-published"><i class="fa fa-exclamation-triangle"></i>&nbsp;Not Published</div>
                </div>
            </div>
        </div>
    </div>
</div>
